function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isObject, isPromise, isFunction, getRootScrollTop, setRootScrollTop } from "../utils";

function isEmptyValue(value) {
  if (Array.isArray(value)) {
    return !value.length;
  }

  if (value === 0) {
    return false;
  }

  return !value;
}

function runSyncRule(value, rule) {
  if (rule.required && isEmptyValue(value)) {
    return false;
  }

  if (rule.pattern && !rule.pattern.test(String(value))) {
    return false;
  }

  return true;
}

function runRuleValidator(value, rule) {
  return new Promise(function (resolve) {
    var returnVal = rule.validator(value, rule);

    if (isPromise(returnVal)) {
      returnVal.then(resolve);
      return;
    }

    resolve(returnVal);
  });
}

function getRuleMessage(value, rule) {
  var message = rule.message;

  if (isFunction(message)) {
    return message(value, rule);
  }

  return message || "";
}

function startComposing(_ref) {
  var target = _ref.target;
  target.composing = true;
}

function endComposing(_ref2) {
  var target = _ref2.target;

  if (target.composing) {
    target.composing = false;
    target.dispatchEvent(new Event("input"));
  }
}

function resizeTextarea(input, autosize) {
  var scrollTop = getRootScrollTop();
  input.style.height = "auto";
  var height = input.scrollHeight;

  if (isObject(autosize)) {
    var maxHeight = autosize.maxHeight,
        minHeight = autosize.minHeight;

    if (maxHeight !== void 0) {
      height = Math.min(height, maxHeight);
    }

    if (minHeight !== void 0) {
      height = Math.max(height, minHeight);
    }
  }

  if (height) {
    input.style.height = "".concat(height, "px");
    setRootScrollTop(scrollTop);
  }
}

function mapInputType(type) {
  if (type === "number") {
    return {
      type: "text",
      inputmode: "decimal"
    };
  }

  if (type === "digit") {
    return {
      type: "tel",
      inputmode: "numeric"
    };
  }

  return {
    type: type
  };
}

function getStringLength(str) {
  return _toConsumableArray(str).length;
}

function cutString(str, maxlength) {
  return _toConsumableArray(str).slice(0, maxlength).join("");
}

export { cutString, endComposing, getRuleMessage, getStringLength, mapInputType, resizeTextarea, runRuleValidator, runSyncRule, startComposing };